/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Link from '@material-ui/core/Link'

const useStyles = makeStyles(() => ({
  root: ({ borderWidth }) => ({
    borderBottom: `${borderWidth}px solid`,
    paddingBottom: 3,
  }),
}))

const Links = ({ borderWidth, className = '', ...props }) => {
  const classes = useStyles({ borderWidth })

  return (
    <Link
      component="a"
      className={`${classes.root} ${className}`}
      underline="none"
      {...props}
    />
  )
}

export default Links
